export default __webpack_public_path__ + "static/smsc_explorer-a2c51e7e9c5be3fbc2d024c2afe16294.png";